import { FontAwesomeIcon } from "./FontAwesomeIcon"
import { faSync } from "@fortawesome/free-solid-svg-icons"

export const Sync = (props) => {
  return <FontAwesomeIcon faIcon={faSync} {...props} />
}
